import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, shareReplay } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProfilePhotoService {
  private readonly http = inject(HttpClient);
  private readonly photos = new Map<string, Observable<string | null>>();
  private readonly graphUrl = environment.apiConfig[3].uri;

  public get(userIdentifier: string): Observable<string | null> {
    const identifier = userIdentifier.trim().toLowerCase();
    if (!identifier) {
      return of(null);
    }

    const cachedPhoto = this.photos.get(identifier);
    if (cachedPhoto) {
      return cachedPhoto;
    }

    // ponytail: app-lifetime cache; add eviction only if the user population becomes large.
    const photo = this.http
      .get(`${this.graphUrl}/users/${encodeURIComponent(identifier)}/photos/48x48/$value`, {
        responseType: 'blob',
      })
      .pipe(
        map(blob => URL.createObjectURL(blob)),
        catchError(() => of(null)),
        shareReplay({ bufferSize: 1, refCount: false }),
      );

    this.photos.set(identifier, photo);
    return photo;
  }
}
